import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=0153614f&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=0153614f&prod&lang=scss&scoped=true"
import style1 from "./Register.vue?vue&type=style&index=1&id=0153614f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0153614f",
  null
  
)

export default component.exports